// Angular
import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Store
import { Store } from '@ngxs/store';
import { QualityState } from '../../quality/state/quality.state';

@Component({
	selector: 'cv-intelligence-initial-page',
	template: `
	<cv-notification class="order-reload-notification" *ngIf="showNotification"
		type="info"
		message="Loading data, please wait <i class='fa fa-spinner fa-spin ms-2'></i>"
		[autoClose]="true">
	</cv-notification>
	`
})
export class InitialPageComponent implements OnInit {
	showNotification = true;
	landingPage: Array<any> = [];

	constructor(private router: Router, private store: Store, private ngZone: NgZone) {
		//
	}

	/**
	 * This configuration was on the inbox
	 * But, for a better control was moved into here
	 */
	async ngOnInit(): Promise<void> {
		// Defaulted to Inbox if something goes wrong
		this.landingPage = ['/intelligence/inbox'];
		try {
			const orderItnelligence = this.store.selectSnapshot(QualityState.getOrderDetail);
			this.landingPage = orderItnelligence.revised
				? [`/intelligence/quality/revisions`, orderItnelligence.id]
				: [`/intelligence/quality/overview`, orderItnelligence.id];
		} catch (e) {
			// Already defaulted to Inbox
		}

		this.ngZone.run(async () => {
			setTimeout(async () => {
				await this.router.navigate(this.landingPage);
			});
		});
	}
}
